import React from "react";

import {ASSETS_LIABILITIES_TYPES} from "../constants";
import List from "../List/List";
import SyncWithRiskProfilePopup from "../List/components/SyncWithRiskProfilePopup";
import {ASSET_DATA_UID} from "../../RiskProfiling/constants";
import {buildAssets} from "../utils";

const AssetsList = (props) => {
  const {
    allowSync,
    customerId,
    onUpdate,
    name,
    helpText,
    data,
    depotsAndCashData,
    onDepotsUpdate,
    showNewBadge,
  } = props;

  const otherAssets = React.useMemo(() => buildAssets(data, depotsAndCashData), [data.updatedAt, depotsAndCashData.updatedAt]);

  const handleUpdate = React.useCallback((action, categoryId, item) =>
    onUpdate(ASSETS_LIABILITIES_TYPES.ASSETS, action, categoryId, item),
    [onUpdate]);

  return (
    <>
      <List
        customerId={customerId}
        stepName={name}
        helpText={helpText}
        data={otherAssets}
        loading={data.loading}
        extraDataLoading={depotsAndCashData.loading}
        onDepotsUpdate={onDepotsUpdate}
        onUpdate={handleUpdate}
        objectType={ASSETS_LIABILITIES_TYPES.ASSETS}
        totalColor={'green'}
        showNewBadge={showNewBadge}
      />
      {!!allowSync && (
        <SyncWithRiskProfilePopup
          customerId={customerId}
          flagName={'other_assets_synced'}
          onUpdate={handleUpdate}
          warnPopupTitle={'Vermögenswerte aus altem Risikoprofil gefunden'}
          syncPopupTitle={'Vorhandene Vermögenswerte gefunden'}
          syncPopupDescription={
            'Es wurden bestehende Vermögenswerte aus dem letzten Risikoprofil gefunden. ' +
            'Bitte wählen Sie, welche Sie übernehmen möchten.'}
          itemSingleLabel={'Vermögenswert'}
          itemPluralLabel={'Vermögenswerte'}
          questionUID={ASSET_DATA_UID}
          syncIncompleteTitle={'Vermögenswerte konnten nicht eindeutig zugeordnet werden'}
          syncIncompleteDescription={<>
            Vermögenswerte aus dem letzten Risikoprofil konnten keinem passenden Kategorie zugeordnet werden.
            Diese Positionen wurden vorläufig der Option „Sonstige“ oder “Weitere” zugewiesen.<br/><br/>
            Bitte prüfen Sie diese. Auf der folgenden Seite können Sie die Zuordnung bei Bedarf manuell anpassen.
          </>}
        >
          Es wurden bestehende Vermögenswerte aus dem letzten Risikoprofil gefunden.
          Möchten Sie diese prüfen und gegebenenfalls in das neue Profil übernehmen?
        </SyncWithRiskProfilePopup>
      )}
    </>
  )
};

AssetsList.defaultProps = {
  name: 'Vermögenswerte',
  allowSync: true
};

export default AssetsList;